(() => {
  const finePointer = window.matchMedia('(pointer: fine)');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const resetCard = (card) => {
    card.classList.remove('is-tracking');
    ['--gs-rx', '--gs-ry', '--gs-media-x', '--gs-media-y', '--gs-shadow-x', '--gs-shadow-y', '--gs-glow-x', '--gs-glow-y'].forEach((property) => {
      card.style.removeProperty(property);
    });
  };

  const bindCard = (card) => {
    if (card.dataset.gs3dReady === 'true') return;
    card.dataset.gs3dReady = 'true';

    let frameId = 0;

    card.addEventListener('pointermove', (event) => {
      if (!finePointer.matches || reduceMotion.matches) return;

      const bounds = card.getBoundingClientRect();
      if (!bounds.width || !bounds.height) return;

      const x = Math.max(0, Math.min(1, (event.clientX - bounds.left) / bounds.width));
      const y = Math.max(0, Math.min(1, (event.clientY - bounds.top) / bounds.height));

      window.cancelAnimationFrame(frameId);
      frameId = window.requestAnimationFrame(() => {
        card.classList.add('is-tracking');
        card.style.setProperty('--gs-rx', `${(0.5 - y) * 5.5}deg`);
        card.style.setProperty('--gs-ry', `${(x - 0.5) * 7}deg`);
        card.style.setProperty('--gs-media-x', `${(0.5 - x) * 7}px`);
        card.style.setProperty('--gs-media-y', `${(0.5 - y) * 5}px`);
        card.style.setProperty('--gs-shadow-x', `${(0.5 - x) * 17}px`);
        card.style.setProperty('--gs-shadow-y', `${21 + y * 10}px`);
        card.style.setProperty('--gs-glow-x', `${x * 100}%`);
        card.style.setProperty('--gs-glow-y', `${y * 100}%`);
      });
    }, { passive: true });

    card.addEventListener('pointerleave', () => {
      window.cancelAnimationFrame(frameId);
      resetCard(card);
    }, { passive: true });
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-gs3d-tilt]').forEach(bindCard);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
